import {
  CommonProps,
  NumberInput,
  type PropsEditorProps,
  Row,
  Section,
} from "./common";

export function RepeaterProps(props: PropsEditorProps): JSX.Element {
  const { field, onUpdate } = props;
  return (
    <>
      <CommonProps {...props} />
      <Section title="Repeater config">
        <Row label="Min items">
          <NumberInput
            value={field.min_items ?? null}
            onChange={(v) => onUpdate({ min_items: v ?? null })}
          />
        </Row>
        <Row label="Max items">
          <NumberInput
            value={field.max_items ?? null}
            onChange={(v) => onUpdate({ max_items: v ?? null })}
          />
        </Row>
        <p className="text-[10px] text-muted-foreground">
          Sub-fields được thêm vào trong canvas (kéo thả vào vùng repeater).
        </p>
      </Section>
    </>
  );
}
